import React, { useState } from 'react';
import { useReveal } from '../lib/useReveal';
import { PlusIcon, MinusIcon } from '../lib/icons';
const FAQS = [{
  q: '¿Necesito experiencia?',
  a: 'No. Está pensado para principiantes, así que podés empezar desde cero sin problema.'
}, {
  q: '¿Es online?',
  a: 'Sí, 100% digital en PDF. Lo recibís a tu correo y lo abrís cuando quieras.'
}, {
  q: '¿Cuándo recibo el material?',
  a: 'Inmediatamente después del pago. El acceso es automático.'
}, {
  q: '¿Puedo hacerlo desde el celular?',
  a: 'Sí. Podés leerlo y aplicarlo desde tu celular, tablet o computadora.'
}, {
  q: '¿Sirve para vender?',
  a: 'Sí, está orientado a emprendimiento pastelero. Vas a aprender a vender desde casa con productos premium.'
}, {
  q: '¿Incluye decoración?',
  a: 'Sí, incluye decoración moderna y presentación profesional en el Tomo 5.'
}];
function FAQItem({
  q,
  a,
  isOpen,
  onClick
}: {
  q: string;
  a: string;
  isOpen: boolean;
  onClick: () => void;
}) {
  return <div className="border border-[#f4b6c2]/30 rounded-2xl bg-white overflow-hidden transition-all duration-300 shadow-[0_4px_20px_rgba(232,154,170,0.04)] mb-3" data-id="element-62">
      <button onClick={onClick} className="w-full flex items-center justify-between p-4 md:p-5 text-left focus:outline-none hover:bg-[#fff8f9] transition-colors" data-id="element-63">
        <span className="text-[#6b4f3a] font-bold text-base md:text-lg pr-4" data-id="element-64">
          {q}
        </span>
        <div className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-colors ${isOpen ? 'bg-[#e89aaa] text-white' : 'bg-[#fdf2f4] text-[#e89aaa]'}`} data-id="element-65">
          {isOpen ? <MinusIcon size={18} data-id="element-66" /> : <PlusIcon size={18} data-id="element-67" />}
        </div>
      </button>
      <div className={`transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-68">
        <div className="p-4 md:p-5 pt-0 text-[#8b6f47] text-sm leading-relaxed border-t border-[#f4b6c2]/20 mt-2" data-id="element-69">
          {a}
        </div>
      </div>
    </div>;
}
export function FAQSection() {
  const [ref, isVisible] = useReveal();
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-12 md:py-16 px-6 bg-[#fff8f9]" data-id="element-70">
      <div className="max-w-3xl mx-auto" data-id="element-71">
        <div className="text-center mb-6" data-id="element-72">
          <span className="inline-block text-[#e89aaa] text-xs font-bold tracking-[0.25em] uppercase mb-3" data-id="element-73">
            ♡ Resolvemos Tus Dudas ♡
          </span>
          <h2 className="text-2xl md:text-4xl font-serif font-bold text-[#6b4f3a]" data-id="element-74">
            Preguntas <span className="italic text-[#e89aaa]" data-id="element-75">Frecuentes</span>
          </h2>
        </div>

        <div ref={ref} className={`reveal ${isVisible ? 'is-visible' : ''}`} data-id="element-76">
          {FAQS.map((faq, i) => <FAQItem key={i} q={faq.q} a={faq.a} isOpen={openIndex === i} onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-77" />)}
        </div>
      </div>
    </section>;
}